import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  GridHeader,
  ReportConfig,
  REPORT_CONFIG
} from '../discovery/REPORT_CONFIG';

import { AppService } from '../../../services/app-service';
import { DomainService } from '../../../services/domain-service';
import { CtvService } from '../../../services/ctv-service';

import { UtilFunctions } from '../util-functions';
import { User } from '../../../models/User';
import { EventBusService } from '../../../services/EventBusService';
import { WatchlistService } from '../../../services/watchlist-service';

const pluralize = require('pluralize');

var validator = require('validator');

export const LOCALSTORAGE_KEY = 'pix-imported-csv-columns'; // APPS LS
export const LOCALSTORAGE_KEY_DOMAINS = 'pix-imported-csv-columns-domains'; // DOMAINS LS

declare var jQuery: any;

@Component({
  selector: 'app-freemium-watchlist',
  templateUrl: './freemium-watchlist.component.html',
  styleUrls: ['./freemium-watchlist.component.scss']
})
export class FreemiumWatchlistComponent implements OnInit {
  public gridData = [];
  public totalCount: number = 0;

  public loadingData: boolean = false;
  public notAllowed: boolean;

  public currentConfig: ReportConfig;

  public followingCount: number = 0;

  public followData;

  public pluralize = pluralize;

  activeSearchQuery: string;

  explicitType: boolean = false;

  watchlistTypeMapping = {
    apps: 'app',
    domains: 'domain',
    ctv: 'ctv'
  };

  prettyNameTypeMapping = {
    apps: 'mobile apps',
    domains: 'domains',
    ctv: 'connected TV apps'
  };

  followIdMapping = {
    apps: 'appId',
    domains: 'adDomain',
    ctv: 'appId'
  };

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    public _userService: User,
    private _appService: AppService,
    private _domainService: DomainService,
    private _ctvService: CtvService,
    private _eventService: EventBusService,
    private _watchlistService: WatchlistService
  ) {}

  ngOnInit(): void {
    this.deserializeQueryParams(this._route.snapshot.queryParams);

    this._watchlistService.syncWatchlist();

    this.loadingData = true;

    this._eventService.watchlistUpdate.subscribe(value => {
      if (!this.explicitType) {
        this.currentConfig = REPORT_CONFIG[0];
        this.refreshWatchlistData();
        if (this.followData.length === 0) {
          this.currentConfig = REPORT_CONFIG[1];
          this.refreshWatchlistData();
          if (this.followData.length === 0) {
            this.currentConfig = REPORT_CONFIG[2];
          }
        }
      } else {
        this.refreshWatchlistData();
      }

      this.loadData();
    });

    this._route.queryParams.subscribe(queryParams => {
      this.deserializeQueryParams(queryParams);
    });
  }

  deserializeQueryParams(queryParams) {
    if (queryParams['type']) {
      this.explicitType = true;
      this.changeType(queryParams['type'], false);
    }

    if (queryParams['appGlobalSearchParam']) {
      this.activeSearchQuery = queryParams['appGlobalSearchParam'];
    }

    if (queryParams['sort']) {
      let sortMap = new Map();

      for (let s of queryParams['sort'].split(',')) {
        let [k, v] = s.split(' ');
        sortMap.set(k, v);
      }

      this.currentConfig.gridHeaders.forEach(header => {
        header.sort = null;

        let sort = sortMap.get(header.key);
        if (sort) {
          header.sort = sort === 'ASC' ? 'sort-asc' : 'sort-desc';
        }
      });
    }
  }

  getFollowCountByType(type) {
    return this._watchlistService.watchlist.getFollowListByType(
      this.watchlistTypeMapping[type]
    ).length;
  }

  refreshWatchlistData() {
    const type = this.currentConfig.key;
    this.followData = this._watchlistService.watchlist.getFollowListByType(
      this.watchlistTypeMapping[type]
    );

    console.log('refreshed watchlist data', this.followData);
  }

  loadData() {
    this.loadingData = true;
    this.notAllowed = false;

    this.gridData = [];

    const type = this.currentConfig.key;

    const limit = 10; // @hardcoded freemium limit

    let filterStrings = [];

    console.log(this.followData);

    if (this.followData.length === 0) {
      this.loadingData = false;
      this.notAllowed = false;
      this.totalCount = 0;
      return;
    }

    this.followData.forEach(follow => {
      filterStrings.push(
        `${this.followIdMapping[type]}=${encodeURIComponent(follow.followId)}`
      );
    });

    let service;

    let dataFunc;

    switch (type) {
      case 'apps':
        service = this._appService;
        dataFunc = this._appService.searchForApps;
        filterStrings.push('device=GLOBAL');
        break;
      case 'domains':
        service = this._domainService;
        dataFunc = this._domainService.searchForDomains;
        filterStrings.push('device=GLOBAL');
        break;
      case 'ctv':
        service = this._ctvService;
        dataFunc = this._ctvService.searchForApps;
        filterStrings.push(
          'device=roku&device=firetv&device=samsung&device=tvos&device=lgtv'
        );
        break;
      default:
        console.log('invalid type', type);
        return;
    }

    filterStrings.push('region=GLOBAL');
    filterStrings.push('isSubDomain=T');

    if (this.activeSearchQuery) {
      filterStrings.push(
        `appGlobalSearchParam=${encodeURIComponent(this.activeSearchQuery)}`
      );
    }

    let sortByValue = this.currentConfig.gridHeaders
      .filter(
        header => header.sort && header.sort.length > 0 && header.sortColumnKey
      )
      .map(header =>
        header.sortColumnKey.concat(header.sort === 'sort-desc' ? ' DESC' : '')
      )
      .join(',');

    if (sortByValue) {
      if (sortByValue.indexOf('bidRange') >= 0) {
        sortByValue = sortByValue.replace('bidRange', 'priceBidLow');
      }

      if (sortByValue.length) {
        filterStrings.push(`sortBy=${encodeURIComponent(sortByValue)}`);
      }
    }

    dataFunc
      .call(service, 0, limit, filterStrings.join('&'))
      .then(data => {
        this.processAppsResponse(data);
        this.loadingData = false;
        this.notAllowed = false;
      })
      .catch(err => {
        if (err.status === 403) {
          this.notAllowed = true;
        }
        this.loadingData = false;
      });
  }

  processAppsResponse(response: any) {
    this.gridData = this.gridData.concat(
      this.prepareAppsData(response['docs'])
    );
    this.totalCount = response['numFound'];
    setTimeout(() => {
      this.loadingData = false;
    }, 500);
    // this.initAppHovers();
    // this.initTooltips();
    if (this.currentConfig.key === 'apps') {
      this.initAppLinks();
    } else if (this.currentConfig.key === 'domains') {
      this.initDomainLinks();
    } else if (this.currentConfig.key === 'ctv') {
      this.initCtvLinks();
    }
    // this.initDiscoveryLinks();
    // this.imageErrorListen();
    // this.initGridHeaders();
  }

  prepareAppsData(docs: Array<any>) {
    docs.forEach((dataItem, index) => {
      this.currentConfig.gridHeaders.forEach(header => {
        let key = header.key;
        if (header.lockedInFreemium && this._userService.isFreemium()) {
          dataItem[key + 'HTML'] =
            '<span class="freemium-lock"><i class="fa fa-lock"></i></span>';
        } else if (header.permission) {
          if (this._userService.hasPermission(header.permission)) {
            dataItem[key + 'HTML'] = this.getDataHTML(
              dataItem,
              header,
              `${index}`
            );
          } else {
            dataItem[key + 'HTML'] = '';
          }
        } else {
          dataItem[key + 'HTML'] = this.getDataHTML(
            dataItem,
            header,
            `${index}`
          );
        }
      });

      let website = UtilFunctions.toWebsiteURL(
        dataItem['developerWebsite'],
        validator
      );
      dataItem['developerWebsite'] = website;
    });
    return docs;
  }

  getDataHTML(dataItem: any, header: GridHeader, indexId: string) {
    try {
      return UtilFunctions.getDataHTML(
        dataItem,
        header,
        this.currentConfig.gridHeaders,
        this._userService
      );
    } catch (e) {
      console.log('error: ', e);
      console.log('dataitem: ', dataItem);
      console.log('header: ', header);
      console.log('indexId: ', indexId);
    }
  }

  async unfollowItem(dataItem: any) {
    jQuery('*[title]').tooltip('hide');
    let appId = dataItem.appId;
    const type = this.currentConfig.key;
    this.totalCount -= 1;
    if (this.currentConfig.key === 'apps' || this.currentConfig.key === 'ctv') {
      appId = dataItem.appId;
      this.gridData = this.gridData.filter(item => item.appId !== appId);
    } else if (this.currentConfig.key === 'domains') {
      appId = dataItem.domain;
      this.gridData = this.gridData.filter(item => item.domain !== appId);
    }
    this.followingCount -= 1;
    await this._watchlistService.removeFollow(
      appId,
      this.watchlistTypeMapping[type],
      dataItem.device,
      true
    );

    this._eventService.updateEyeNumFollowing.emit(true);
  }

  changeType(type: string, refresh: boolean = true) {
    if (this.loadingData) return;

    let configId;

    let config = REPORT_CONFIG.find(d => d.key === type);

    this.currentConfig = config;

    this.clearAppGlobalSearch(refresh);

    this.updateQueryParams({
      type: type
    });

    if (refresh && !this.loadingData) {
      this.refreshWatchlistData();
      this.loadData();
    }
  }

  appGlobalSearch(searchQuery?: any, refresh: boolean = true) {
    if (this.activeSearchQuery !== searchQuery) {
      this.activeSearchQuery = searchQuery;

      this.updateQueryParams({
        appGlobalSearchParam: this.activeSearchQuery
      });

      if (refresh) this.loadData();
    }
  }

  updateQueryParams(params) {
    let currentParams = this._route.snapshot.params;

    let newParams = {};

    for (let k of Object.keys(currentParams)) {
      newParams[k] = currentParams[k];
    }

    for (let k of Object.keys(params)) {
      let val = params[k];

      if (!val) delete newParams[k];
      else newParams[k] = val;
    }

    console.log(newParams);

    this._router.navigate([], { queryParams: newParams });
  }

  clearAppGlobalSearch(refresh: boolean = true) {
    this.appGlobalSearch(null, refresh);
  }

  toggleSort(selectedGridHeader: GridHeader) {
    if (selectedGridHeader.sortColumnKey && !this.loadingData) {
      let sortParam = '';
      this.currentConfig.gridHeaders.forEach(gridHeader => {
        if (gridHeader.key === selectedGridHeader.key) {
          const sort = gridHeader.sort;
          if (!sort) {
            gridHeader.sort = 'sort-desc';
            if (
              gridHeader.sortColumnKey === 'appTitle' ||
              gridHeader.sortColumnKey === 'domain'
            ) {
              gridHeader.sort = 'sort-asc';
            }
          } else if (sort === 'sort-desc') {
            gridHeader.sort = 'sort-asc';
            if (
              gridHeader.sortColumnKey === 'appTitle' ||
              gridHeader.sortColumnKey === 'domain'
            ) {
              gridHeader.sort = '';
            }
          } else {
            gridHeader.sort = '';
            if (
              gridHeader.sortColumnKey === 'appTitle' ||
              gridHeader.sortColumnKey === 'domain'
            ) {
              gridHeader.sort = 'sort-desc';
            }
          }

          if (gridHeader.sort) {
            let dir = gridHeader.sort === 'sort-desc' ? 'DESC' : 'ASC';
            sortParam = `${gridHeader.key} ${dir}`;
          }
        } else {
          gridHeader.sort = '';
        }
      });

      this.updateQueryParams({
        sort: sortParam
      });

      this.loadData();
    }
  }

  initDomainLinks() {
    setTimeout(() => {
      let domainLink = jQuery('.domain-link');
      domainLink.css('cursor', 'pointer');
      domainLink.on('click', event => {
        event.stopPropagation();
        if (jQuery('div.details-overlay-transition-message').length <= 0) {
          const classList = jQuery(event.target).attr('class').split(' ');
          let region = classList
            .filter(cl => cl.indexOf('region-') >= 0)[0]
            .replace('region-', '');
          if (region === 'Non') {
            region = 'NON-US';
          }
          const device = classList
            .filter(cl => cl.indexOf('device-') >= 0)[0]
            .replace('device-', '');
          const domainid = classList
            .filter(cl => cl.indexOf('id-') >= 0)[0]
            .replace('id-', '');
          const domain = classList
            .filter(cl => cl.indexOf('domainname-') >= 0)[0]
            .replace('domainname-', '');
          const section = classList
            .filter(cl => cl.indexOf('section-') >= 0)[0]
            .replace('section-', '');
          this._router.navigate(['/insight/domains/', domain, region, device], {
            queryParams: { section: `#${section}` }
          });
        }
      });
    }, 300);
  }

  initAppLinks() {
    setTimeout(() => {
      let appLink = jQuery('.app-link');
      appLink.css('cursor', 'pointer');
      appLink.on('click', event => {
        event.stopPropagation();
        if (jQuery(event.target).text() !== 'N/A') {
          if (jQuery('div.details-overlay-transition-message').length <= 0) {
            const classList = jQuery(event.target).attr('class').split(' ');
            let region = classList
              .filter(cl => cl.indexOf('region-') >= 0)[0]
              .replace('region-', '');
            const device = classList
              .filter(cl => cl.indexOf('device-') >= 0)[0]
              .replace('device-', '');
            const appid = classList
              .filter(cl => cl.indexOf('appid-') >= 0)[0]
              .replace('appid-', '');
            const indexid = classList
              .filter(cl => cl.indexOf('id-') >= 0)[0]
              .replace('id-', '');
            const store = classList
              .filter(cl => cl.indexOf('store-') >= 0)[0]
              .replace('store-', '');
            const section = classList
              .filter(cl => cl.indexOf('section-') >= 0)[0]
              .replace('section-', '');

            this._router.navigate(
              ['/insight/apps/', appid, region, store, device],
              {
                queryParams: { section: `#${section}` }
              }
            );
          }
        }
      });
    }, 300);
  }

  initCtvLinks() {
    setTimeout(() => {
      let appLink = jQuery('.ctv-link');
      appLink.css('cursor', 'pointer');
      appLink.on('click', event => {
        event.stopPropagation();
        if (jQuery(event.target).text() !== 'N/A') {
          if (jQuery('div.details-overlay-transition-message').length <= 0) {
            const classList = jQuery(event.currentTarget)
              .attr('class')
              .split(' ');
            let region = classList
              .filter(cl => cl.indexOf('region-') >= 0)[0]
              .replace('region-', '');
            const device = classList
              .filter(cl => cl.indexOf('device-') >= 0)[0]
              .replace('device-', '');
            const appid = classList
              .filter(cl => cl.indexOf('appid-') >= 0)[0]
              .replace('appid-', '');
            const indexid = classList
              .filter(cl => cl.indexOf('id-') >= 0)[0]
              .replace('id-', '');
            const section = classList
              .filter(cl => cl.indexOf('section-') >= 0)[0]
              .replace('section-', '');
            const appIconElement = jQuery(`img.appIcon.id-${indexid}`)[0];
            const rect = UtilFunctions.focusLogo(appIconElement);
            if (region === 'North') {
              region = 'NA';
            }
            this._router.navigate(['/insight/ctv/', appid, region, device], {
              queryParams: { section: `#${section}` }
            });
          }
        }
      });
    }, 300);
  }
}
